const lib = typeof window !== "undefined" && window.PageState ? window.PageState : {};

export default lib;



// WEBPACK FOOTER //
// ./src/shared/util/PageState.js